import { SortableChurchUnit } from './sortable-church-unit.model';
import { StudentListing, CheckableStudentListing } from '../students/student-listing.model';

export class HomeWardWithStudents {
    homeWard: SortableChurchUnit;
    students: StudentListing[];
}

export class HomeWardWithCheckAbleStudents {
    homeWard: SortableChurchUnit;
    students: CheckableStudentListing[];
}

